import { withInstall, withNoopInstall } from '@zoryn/utils'
import Select from './src/select.vue'
import Option from './src/option.vue'
import OptionGroup from './src/option-group.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZSelect: SFCWithInstall<typeof Select> & {
  Option: typeof Option
  OptionGroup: typeof OptionGroup
} = withInstall(Select, {
  Option,
  OptionGroup,
})
export default ZSelect
export const ZOption: SFCWithInstall<typeof Option> = withNoopInstall(Option)
export const ZOptionGroup: SFCWithInstall<typeof OptionGroup> =
  withNoopInstall(OptionGroup)

export * from './src/token'
export * from './src/select'

export type {
  SelectContext,
  OptionPublicInstance as SelectOptionProxy,
  OptionBasic,
} from './src/type'
